import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import favicon from './favicon.ico';
import logo from './logo.svg';

import './index.css';

const Header = () => (
  <div
    style={{
      textAlign: 'center',
      borderBottom: '1px solid rgba(228, 228, 228, 0.5)',
      marginBottom: '10px',
    }}
  >
    <h1
      style={{
        padding: '0.25em',
      }}
    >
      <img src={logo} alt="StatMuse" />
    </h1>
  </div>
);

const Footer = () => (
  <div
    style={{
      borderTop: '1px solid rgba(228, 228, 228, 0.5)',
    }}
  >
    <div className="container-rows center">
      <div className="item right-border">© StatMuse</div>
      <div className="item right-border">
        <a href="https://www.statmuse.com/privacy">Privacy Policy</a>
      </div>
      <div className="item">
        <a href="https://www.statmuse.com/terms">Terms of Service</a>
      </div>
    </div>
  </div>
);

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="StatMuse on Slack"
      meta={[
        { name: 'description', content: 'Add StatMuse on Slack' },
        { name: 'keywords', content: 'statmuse, slack, sports, chatbot' },
        { name: 'slack-app-id', content: 'A7U7ZN46Q' },
      ]}
    >
      <link rel="shortcut icon" type="image/x-icon" href={favicon} />
      <link
        rel="stylesheet"
        href="//fonts.googleapis.com/css?family=Source+Sans+Pro:400,400italic,300,600"
      />
    </Helmet>
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js